export const getSessionCreatedAt = (log, isSkip = false) => {
  if (isSkip) return new Date().toISOString();

  const rawTimestamp = log?.analysisTimestampUTC;
  if (!rawTimestamp) return new Date().toISOString();

  const normalized = rawTimestamp.replace(' (UTC)', 'Z').replace(' ', 'T');
  const date = new Date(normalized);

  if (Number.isNaN(date.getTime())) {
    return new Date().toISOString();
  }

  return date.toISOString();
};

export const getErrorRateFromLog = (log, isSkip = false) => {
  if (isSkip) return 1;

  const totalErrors = Number(log?.summary?.total_errors ?? 0);
  const totalTargetPhonemes = Number(log?.summary?.total_target_phonemes ?? 0);

  if (totalTargetPhonemes <= 0) return 1;

  const errorRate = totalErrors / totalTargetPhonemes;
  return Math.min(1, Math.max(0, errorRate));
};

export const getCorrectRateFromLog = (log, isSkip = false) => {
  const errorRate = getErrorRateFromLog(log, isSkip);
  return Math.min(1, Math.max(0, 1 - errorRate));
};
